export default {
    Window: {
        defaultPosition: {
            xPos: "40px",
            yPos: "25px",
        },
        defaultSize: {
            width: "400px",
            height: "510px",
        },
        gutterSize: 15,
        hugHorizontal: "left",
        rootId: "nit-alme-window-root",
        enableFocusTrap: true
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/window.ts